export const DAY_OPTIONS = [
  {
    value: "monday",
    label: "Monday",
    selected: false,
  },
  {
    value: "tuesday",
    label: "Tuesday",
    selected: false,
  },
  {
    value: "wednesday",
    label: "Wednesday",
    selected: false,
  },
  {
    value: "thursday",
    label: "Thursday",
    selected: false,
  },
  {
    value: "friday",
    label: "Friday",
    selected: false,
  },
  {
    value: "saturday",
    label: "Saturday",
    selected: false,
  },
  {
    value: "sunday",
    label: "Sunday",
    selected: false,
  },
];

export const TIME_OPTIONS = [
  {
    id: "00:00",
    value: "00:00",
  },
  {
    id: "01:00",
    value: "01:00",
  },
  {
    id: "02:00",
    value: "02:00",
  },
  {
    id: "03:00",
    value: "03:00",
  },
  {
    id: "04:00",
    value: "04:00",
  },
  {
    id: "05:00",
    value: "05:00",
  },
  {
    id: "06:00",
    value: "06:00",
  },
  {
    id: "07:00",
    value: "07:00",
  },
  {
    id: "08:00",
    value: "08:00",
  },
  {
    id: "09:00",
    value: "09:00",
  },
  {
    id: "10:00",
    value: "10:00",
  },
  {
    id: "11:00",
    value: "11:00",
  },
  {
    id: "12:00",
    value: "12:00",
  },
  {
    id: "13:00",
    value: "13:00",
  },
  {
    id: "14:00",
    value: "14:00",
  },
  {
    id: "15:00",
    value: "15:00",
  },
  {
    id: "16:00",
    value: "16:00",
  },
  {
    id: "17:00",
    value: "17:00",
  },
  {
    id: "18:00",
    value: "18:00",
  },
  {
    id: "19:00",
    value: "19:00",
  },
  {
    id: "20:00",
    value: "20:00",
  },
  {
    id: "21:00",
    value: "21:00",
  },
  {
    id: "22:00",
    value: "22:00",
  },
  {
    id: "23:00",
    value: "23:00",
  },
];

export const DURATION_OPTIONS = [
  {
    id: "3-hour",
    value: "3 hours",
  },
  {
    id: "4-hour",
    value: "4 hours",
  },
  {
    id: "6-hour",
    value: "6 hours",
  },
  {
    id: "8-hour",
    value: "8 hours",
  },
  {
    id: "10-hour",
    value: "10 hours",
  },
  {
    id: "12-hour",
    value: "12 hours",
  },
];
